export const formatRating = (rating: number) => {
  const dec = rating % 1
  if (dec < 0.5) {
    const result = rating - dec

    return result.toFixed(1)
  }

  return rating - dec + 0.5
}
